module.exports = __webpack_public_path__ + "img/coroa.c6d5cd5e.svg";